module.exports = __webpack_public_path__ + "static/media/icPlayerCanceled.bf342945.svg";